module.exports = __webpack_public_path__ + "img/table1-bg.3233b1d0.svg";